import { HttpClient } from '../../../httpClient'
import { OpalApi } from '../../../schema'

type UpdateBlockConnectorV3 = OpalApi<'UpdateBlockConnectorV3', 201>

export const updateBlockConnector: UpdateBlockConnectorV3 = async (
  args = {}
) => {
  const url = new URL(
    `/loupe/v3/block_connectors/${args.params?.path.block_connector_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
